<template>
  <div class="grid data-container" :class="{ 'data-container--small': dataContainerSmall }">
    <div class="xs-6 data-container__block dea-text--left">
      <p class="dea-heading--medium__xm">Nome</p>
      <div class="dea-heading--regular__xm">{{ user.datiLogin.nome }}</div>
    </div>
    <div class="xs-6 data-container__block data-container__block--right dea-text--left">
      <p class="dea-heading--medium__xm">Cognome</p>
      <div class="dea-heading--regular__xm">{{ user.datiLogin.cognome }}</div>
    </div>
    <div class="xs-6 data-container__block data-container__block--right dea-text--left">
      <p class="dea-heading--medium__xm">Email</p>
      <div class="dea-heading--regular__xm data-container__block data-container__block--email-field">
        {{ user.datiLogin.email }}
      </div>
    </div>
    <div v-if="user.datiLogin.telefono" class="xs-6 data-container__block dea-text--left">
      <p class="dea-heading--medium__xm">Telefono</p>
      <div class="dea-heading--regular__xm">{{ user.datiLogin.telefono }}</div>
    </div>
    <slot>
      <div
        v-if="user.utenteAnagraficaScuola && user.utenteAnagraficaScuola.length"
        class="xs-6 data-container__block dea-text--left"
      >
        <p class="dea-heading--medium__xm">Scuola</p>
        <div v-for="school in user.utenteAnagraficaScuola" :key="school.id" class="dea-heading--regular__xm">
          {{ school.istituto }} ({{ school.localita }})
        </div>
      </div>
      <div
        v-if="user.utenteAnagraficaScuola && user.utenteAnagraficaScuola.length"
        class="xs-6 data-container__block dea-text--left"
      >
        <p class="dea-heading--medium__xm">Grado Scolastico</p>
        <div class="data-container__info">
          <div v-for="(grade, index) in schoolsGradeName()" :key="index">
            <span class="dea-heading--regular__xm">{{ grade }}</span>
          </div>
          <!-- FIXME: Do we need this? -->
          <ShowError v-if="showTargetError" class="dea-heading--regular__xm"
            >Il tuo grado scolastico non è compatibile col corso scelto</ShowError
          >
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "PersonalData",
  props: {
    showTargetError: Boolean,
    user: {
      type: Object,
      default: () => ({}),
    },
    dataContainerSmall: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    schoolsGradeName() {
      const arrayOfGrades = [];
      /* eslint-disable array-callback-return */
      this.user.utenteAnagraficaScuola.filter(el => {
        if (el.ordineScolastico && arrayOfGrades.indexOf(el.ordineScolastico) === -1) {
          arrayOfGrades.push(el.ordineScolastico);
        }
      });
      /* eslint-enable array-callback-return */

      return arrayOfGrades;
    },
  },
};
</script>
